import translate from '@/utils/translate';
import {BaseFilterOption} from '@/types/models/creator-crm/filter';

function mapOptions(options: BaseFilterOption[]) {
  return options.map((option) => ({
    ...option,
    label: translate(option.localeLabelKey),
  }));
}

export default mapOptions;
